import { useMedia } from 'react-use';

import { mediumMobileHeightAndAbove } from 'style/mediaQuery';

export const useIsMediumMobileHeightAndAbove = () =>
  useMedia(mediumMobileHeightAndAbove);
